<template>
    <div
            class="row-panel"
            v-right-click="rightMenuObj"
    >点击此处自定义右键</div>
</template>
<script>
    import { defineComponent } from "vue";
    export default defineComponent({
        computed: {
            rightMenuObj(){
                const obj = {
                    this: this,
                    text: [
                        "查看资料",
                        { content: "复制用户id", status: false},
                        "移除该会话",
                        "在联系人中查看",
                        "在单聊窗口中打开",
                        "会话置顶"
                    ],
                    handler: {
                        checkingData(parameter) {
                            console.log(parameter);
                            console.log("查看资料点击事件");
                        },
                        copyId() {
                            console.log("复制用户id点击事件");
                        },
                        removeItem() {
                            console.log("移除会话点击事件");
                        },
                        showContact() {
                            console.log("在联系人中查看");
                        },
                        showSingleChat() {
                            console.log("在单聊窗口中打开");
                        },
                        topConversation() {
                            console.log("会话置顶");
                        }
                    }
                };
                return obj;
            }
        }
    })
</script>